module.exports = __webpack_public_path__ + "img/checkout_complete.199184d8.svg";